import { useState } from 'react';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import MenuIcon from '@mui/icons-material/Menu';
import AppMenuDrawer from 'views/Navigation/AppMenuDrawer/AppMenuDrawer';

const useStyles = makeStyles(() => ({
  showMenuButton: {
    zIndex: 2000,
    position: 'fixed',
    marginLeft: 9,
    marginTop: 2,
    borderRadius: 24,
    minWidth: 48,
    left: 0,
    top: 0,
  },
  showMenuIcon: {
    background: 'rgba(255, 255, 255, 0.5)',
    height: '1.5em',
    width: '1.5em',
  },
}), { name: 'MobileMenu' });

const MobileMenu = (): JSX.Element => {
  const classes = useStyles();
  const [isOpened, setIsOpened] = useState(false);

  const onMenuItemClick = (): void => {
    setIsOpened(false);
  };

  return <>
    <AppMenuDrawer mobile isOpened={isOpened} setIsOpened={setIsOpened} onMenuItemClick={onMenuItemClick} />
    <Button
      className={classes.showMenuButton}
      variant='text'
      onClick={(): void => setIsOpened(!isOpened)}
    >
      <MenuIcon className={classes.showMenuIcon} />
    </Button>
  </>;
};

export default MobileMenu;
